import { defineStore } from 'pinia'

import api from '@/api/common.js'
import { parseToJson } from '@/utils/parser.js'

const mappedConfigs = (configs) => {
  const mappedConfigs = []
  for (const i in configs) {
    if (Object.prototype.hasOwnProperty.call(configs, i)) {
      const value = configs[i].value
      mappedConfigs[configs[i].id] = value
    }
  }
  return mappedConfigs
}

// Holds the in-flight/settled getAffiliateConfigs() fetch so
// ensureAffiliateConfigsLoaded() can await the real completion instead of
// polling reactive state. Module-scoped (not store state) since a Promise
// isn't meaningful to make reactive.
let affiliateConfigsPromise = null

export const useCommonStore = defineStore('common', {
  state: () => ({
    affiliateConfigs: {
      init: true
    },
    isGetAffiliateConfigsDone: false,
    previousRoutes: []
  }),
  actions: {
    getAffiliateConfigs ({ success, fail } = {}) {
      affiliateConfigsPromise = api.getAffiliateConfigs()
        .then(response => {
          this.affiliateConfigs = response.body.data
          const configs = parseToJson(response.body.data.value)
          this.affiliateConfigs = mappedConfigs(configs)
          this.isGetAffiliateConfigsDone = true
          success?.(response)
        })
        .catch(error => {
          fail?.(error)
          this.affiliateConfigs = {}
        })
      return affiliateConfigsPromise
    },
    // Resolves once affiliateConfigs has settled (success or failure).
    // Reuses the fetch App.vue's root init already kicked off instead of
    // requesting it again, and resolves immediately if it already completed.
    ensureAffiliateConfigsLoaded () {
      return affiliateConfigsPromise || this.getAffiliateConfigs()
    },
    addPreviousRoute (route) {
      this.previousRoutes.push(route)
    }
  },
  getters: {
    privacyPolicyLink: state => state.affiliateConfigs.privacyPolicyLink,
    tncLink: state => state.affiliateConfigs.tncLink,
    blibliCareLink: state => state.affiliateConfigs.blibliCareLink,
    micrositeLink: state => state.affiliateConfigs.micrositeLink,
    affiliateCommunity: state => state.affiliateConfigs.affiliateCommunity,
    socialMediaAccount: state => state.affiliateConfigs.socialMediaAccount,
    missionConfigs: state => state.affiliateConfigs.mission,
    customerCareConfigs: state => state.affiliateConfigs.customerCare,
    contextualPrice: state => state.affiliateConfigs.contextualPrice,
    tiketMerchantName: state => state.affiliateConfigs.tiketMerchantName,
    tenantRedirectUrl: state => state.affiliateConfigs.tenantRedirectUrl,
    activeProductRecommendation: state => state.affiliateConfigs.activeProductRecommendation,
    directIndirectFeature: state => state.affiliateConfigs.directIndirectFeature,
    topSellingCategoryCarouselDisplayed: state => state.affiliateConfigs.topSellingCategoryCarouselDisplayed,
    tagLinkConfigs: state => state.affiliateConfigs.tagLink
  }
})
